import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-select-dropdown',
  templateUrl: './select-dropdown.component.html',
  styleUrls: ['./select-dropdown.component.scss']
})
export class SelectDropdownComponent {
  @Input() id:string;
  @Input() name:string;
  @Input() selectClass:string='';
  @Input() isRequired:boolean;
  @Input() isDisabled:boolean;
  @Input() options: any[] = [];
  @Input() selectedValue: string = ''
  @Input() optionDisable: any[] = [];
  @Output() valueChanged = new EventEmitter<string>();  

  ngOnInit(): void {
  }

}
